import { Button } from '../../../../../../widgets/buttons';
import { Checkbox } from '../../../../../../widgets/checkbox';
import { FormControl } from '../../../../../../widgets/formControl';
import React from 'react';
import { ValueInput } from 'src/components/widgets/FormBuilderTool/editForm';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import useComposerStore from '../../../configurator-composer/composer/composerStore';
import Stack from '../../../../../../widgets/stack/stack';
const ComposerStartedTitle = styled.h2`
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
    text-align: center;
`;

const ComposerStartedDescription = styled.p`
    text-align: center;
    margin-bottom: 2rem;
    max-width: 600px;
    line-height: 1.5;
`;

const ComposerStartedButtonContainer = styled.div`
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: center;
`;

const AttributesButton = styled(Button)`
    color: #fff;
    gap: 0.5rem;
`;

const AIButton = styled(AttributesButton)`
    background: linear-gradient(135deg, #8a2be2, #9370db);
    &:hover {
        opacity: 0.9;
    }
`;

const ComposerStartedContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    align-items: center;
    align-content: center;
    flex-grow: 1;
    padding: 8em;
    justify-content: start;
    text-align: center;
`;
const ComposerStartedInnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 400px;
    gap: 12px;
`;

const ComposerSettings: React.FC = ({}) => {
    const [productQuantity, setProductQuantity] = useComposerStore((state) => [state.productQuantity, state.setProductQuantity]);

    const onCheck = (checked: boolean) => {
        const productQuantity = checked ? new MPlaza.QuantityRule() : null;
        setProductQuantity(productQuantity);
    };

    const onPropertyChange = (property: 'minQuantity' | 'maxQuantity' | 'step', value: number | undefined | null) => {
        if (productQuantity) {
            //check if min > max or max < min
            if (
                value &&
                property === 'minQuantity' &&
                value !== undefined &&
                productQuantity.get('maxQuantity') !== undefined &&
                value > (productQuantity.get('maxQuantity') || Number.MAX_VALUE)
            ) {
                // If min > max, set min to max
                productQuantity.set('minQuantity', productQuantity.get('maxQuantity'));
            } else if (
                value &&
                property === 'maxQuantity' &&
                value !== undefined &&
                productQuantity.get('minQuantity') !== undefined &&
                value < (productQuantity.get('minQuantity') || 0)
            ) {
                // If max < min, set max to min
                productQuantity.set('maxQuantity', productQuantity.get('minQuantity'));
            }
            productQuantity.set(property as any, value);
            setProductQuantity(productQuantity.clone());
        }
    };

    return (
        <ComposerStartedContainer>
            <ComposerStartedInnerContainer>
                <Checkbox checked={!!productQuantity} onChange={onCheck} label={T._('Allow the user to change quantities', 'Admin')} />
                {!!productQuantity && (
                    <>
                        <Stack>
                            <FormControl
                                label={T._('Minimum Quantity', 'Admin')}
                                tooltipLabelHtml={T._("Leave empty if you don't want a minimum quantity. It will be 1.", 'Admin')}
                            >
                                <ValueInput
                                    type='number'
                                    value={productQuantity.get('minQuantity') || ''}
                                    min={productQuantity.get('minQuantity') || 1}
                                    max={(productQuantity.get('maxQuantity') || Number.MAX_VALUE) - 1}
                                    onChange={(e) => onPropertyChange('minQuantity', e.target.valueAsNumber)}
                                />
                            </FormControl>
                            <FormControl
                                label={T._('Maximum Quantity', 'Admin')}
                                tooltipLabelHtml={T._("Leave empty if you don't want a maximum quantity.", 'Admin')}
                            >
                                <ValueInput
                                    type='number'
                                    value={productQuantity.get('maxQuantity') || ''}
                                    min={productQuantity.get('minQuantity') || 0}
                                    max={productQuantity.get('maxQuantity') || Number.MAX_VALUE}
                                    onChange={(e) => onPropertyChange('maxQuantity', e.target.valueAsNumber)}
                                />
                            </FormControl>
                            <FormControl label={T._('Step', 'Admin')} tooltipLabelHtml={T._("Leave empty if you don't want a step value.", 'Admin')}>
                                <ValueInput
                                    type='number'
                                    value={productQuantity.get('step') || ''}
                                    min={1}
                                    onChange={(e) => onPropertyChange('step', e.target.valueAsNumber)}
                                />
                            </FormControl>
                        </Stack>
                    </>
                )}
            </ComposerStartedInnerContainer>
        </ComposerStartedContainer>
    );
};

export default ComposerSettings;
